import auth from "./auth";
import common from "./common";
import graph from "./graph";
import landing from "./landing";
import projects from "./projects";
import timeSeries from "./timeSeries";
import worksite from "./worksite";
import drone from "./drone";

const ja = {
  auth,
  common,
  graph,
  landing,
  projects,
  timeSeries,
  worksite,
  drone,
} as const;

export default ja;
